module.exports = __webpack_public_path__ + "static/media/interactive-pic-book-preview-01.c4b9ffde.jpg";